import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Location from "./Location/location";
import Department from "./Department/Deparment";
import ImportLocation from "./Location/ImportLocation";
import ImportDepartment from "./Department/ImportDepartment";

const LocationAndDepartment = () => {
  const navigate = useNavigate();
  const [showImportLocation, setShowImportLocation] = useState(false);
  const [showImportDepartment, setShowImportDepartment] = useState(false);
  // Get user details from auth slice, which is persisted in localStorage
  const user = useSelector((state) => state.auth.user);
  const orgMode = user?.orgStructureMode;
  const orgModeLocked = user?.orgModeLocked;

  // "location-first" means show Location first.
  // "department-first" means show Department first.
  const showLocationFirst = orgMode !== "department-first";

  // Prevent browser back navigation when org mode is locked.
  useEffect(() => {
    if (orgModeLocked) {
      window.history.pushState(null, "", window.location.href);

      const handlePopState = () => {
        window.history.pushState(null, "", window.location.href);
      };

      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }

    return undefined;
  }, [orgModeLocked]);

  if (showImportLocation) {
    return (
      <div className="md:p-6 lg:p-0 bg-[#F5F5F5] overflow-hidden">
        <div>
          <ImportLocation onClose={() => setShowImportLocation(false)} />
        </div>
      </div>
    );
  }

  if (showImportDepartment) {
    return (
      <div className="md:p-6 lg:p-0 bg-[#F5F5F5] overflow-hidden">
        <div>
          <ImportDepartment onClose={() => setShowImportDepartment(false)} />
        </div>
      </div>
    );
  }

  return (
    <div className="relative md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      <div className="w-full max-w-5xl mb-4 flex items-center">
        <div
          className="w-[32px] h-[32px] rounded-full border-2 border-[#06513D] flex items-center justify-center cursor-pointer mr-3 transition-colors hover:bg-[#06513D] hover:text-white text-[#06513D] group"
          onClick={() => navigate(-1)}
        >
          <ArrowLeftOutlined className="text-[16px] font-bold group-hover:text-white" />
        </div>

        <h1
          className="text-[#06513D] text-[18px] sm:text-[22px] font-bold m-0"
          style={{ fontFamily: "Calibri, sans-serif" }}
        >
          Add Locations & Departments
        </h1>
      </div>

      <div className="bg-white border border-[#3BA2B959] rounded-xl p-6 shadow-md space-y-8">
        {showLocationFirst ? (
          <>
            <div>
              <Location
                onOpenImportLocation={() => setShowImportLocation(true)}
              />
            </div>
            <div>
              <Department
                onOpenImportDepartment={() => setShowImportDepartment(true)}
              />
            </div>
          </>
        ) : (
          <>
            <div>
              <Department
                onOpenImportDepartment={() => setShowImportDepartment(true)}
              />
            </div>
            <div>
              <Location
                onOpenImportLocation={() => setShowImportLocation(true)}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LocationAndDepartment;
